const addUniqueNotifications = (state, notifications, existingNotifications) => {
    const existingIds = new Set(existingNotifications.map(notification => notification.id));
    const newNotifications = notifications.filter(notification => !existingIds.has(notification.id));
    state.push(...newNotifications);
};

export default {
  setNotifications(state, payload) {
    state.notifications = payload;
  },
  setAddNotification(state, { notification, type }) {
    state[type].push(notification);
  },
  setUpdateNotifications(state, newNotifications) {
    
    if (!newNotifications) return;
    
    const uniqueNotifications = newNotifications.filter((newNotification) => {
      return !state.notifications.some(
        (existingNotification) => existingNotification.id === newNotification.id
      );
    });

    state.notifications = [...uniqueNotifications, ...state.notifications];
  },
  setUnreadNotificationsCount(state, payload) {
    state.unreadNotificationsCount = payload;
  },
  setUnreadNotifications(state, payload) {
    addUniqueNotifications(state.unreadNotifications, payload.results, state.unreadNotifications);
  },
  setReadNotifications(state, payload) {
    state.readNotificationsCount = payload.count;
    addUniqueNotifications(state.readNotifications, payload.results, state.readNotifications);
  },
  setIsNotificationLoaded(state, payload) {
    state.isLoaded = payload;
  },
  setNotificationsCount(state, payload) {
    state.count = payload;
  },  
  setRemoveNotification(state, { notification, type }) {   
    const index = state[type].findIndex(n => n.id === notification.id);
    if (index !== -1) {
        state[type].splice(index, 1);   
    }
  },

  // Add the mark all as read mutation here
  MARK_ALL_NOTIFICATIONS_READ(state) {
    // Move all unread notifications to read notifications
    const unreadToMove = [...state.unreadNotifications];
    
    // Add to read notifications (avoiding duplicates)
    unreadToMove.forEach(notification => {
      notification.read = true;
      const existsInRead = state.readNotifications.some(n => n.id === notification.id);
      if (!existsInRead) {
        state.readNotifications.unshift(notification); // Add to beginning to maintain order
      }
    });
    
    // Clear unread notifications
    state.unreadNotifications = [];
    
    // Update counts
    state.unreadNotificationsCount = 0;
    state.readNotificationsCount = state.readNotifications.length;
    
    // Also update the main notifications array if it exists
    if (state.notifications && state.notifications.length > 0) {
      state.notifications = state.notifications.map(notification => ({
        ...notification,
        read: true
      }));
    }
  },

  // setIsRead(state, notificationId) {
  //   const notification = state.notifications.find(
  //     (n) => n.id === notificationId
  //   );
  //   if (notification) {      
  //     notification.read = true;
  //     console.log(notification);
  //   }
  // },

  setClearNotifications(state){
    state.notifications = [];
  }
};